// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_By","fallback":"e_Cy","s40":"e_Dy","s32":"e_Ey"};